import React from "react";
import { Lock, Unlock, Trash2, X } from "lucide-react";

// Floating action bar that appears when ≥2 grid cells are selected. Renders
// at the bottom-centre of the viewport above all other UI.
export default function BulkActionBar({ count, onClear, onLock, onUnlock, onDelete }) {
  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 bottom-4 bg-bg-surface border border-amber px-3 py-2 flex items-center gap-3 z-50 animate-slide-up shadow-[0_8px_32px_rgba(0,0,0,0.6)]"
      data-testid="bulk-action-bar"
    >
      <span className="mono text-2xs uppercase tracking-widest text-amber">{count} SELECTED</span>
      <div className="h-4 w-px bg-line" />
      <button onClick={onLock} className="btn-ghost" data-testid="bulk-lock"><Lock className="w-3 h-3" /> LOCK</button>
      <button onClick={onUnlock} className="btn-ghost" data-testid="bulk-unlock"><Unlock className="w-3 h-3" /> UNLOCK</button>
      <button onClick={onDelete} className="btn-ghost text-red border-red/40 hover:bg-red-glow" data-testid="bulk-delete">
        <Trash2 className="w-3 h-3" /> DELETE
      </button>
      <div className="h-4 w-px bg-line" />
      <button onClick={onClear} className="btn-ghost" data-testid="bulk-clear"><X className="w-3 h-3" /></button>
    </div>
  );
}
